import { render, staticRenderFns } from "./BuildingLongAbsenceList.vue?vue&type=template&id=4331f25c&scoped=true&"
import script from "./BuildingLongAbsenceList.vue?vue&type=script&lang=js&"
export * from "./BuildingLongAbsenceList.vue?vue&type=script&lang=js&"
import style0 from "./BuildingLongAbsenceList.vue?vue&type=style&index=0&id=4331f25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4331f25c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VForm,VRow})
